export const OLD_PRUI_KEY = 'ap[a][partnerRecordUniqueIdentifier]';
export const NEW_PRUI_KEY = 'partnerRecordUniqueIdentifier';
